module.exports = __webpack_public_path__ + "static/media/correct-2.a1475969.mp3";